import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { IPaging } from 'common/models/IPaging';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getRenters } from 'modules/_common/api';

export const useQueryRenters = ({ pageNo, pageSize }: IPaging, enabled?: boolean | undefined) => {
  const {
    data: rentersData,
    isLoading: rentersIsLoading,
    isError: rentersIsError,
  } = useQuery([QUERY_KEYS.RENTALS_CONTRACTS_RENTERS], () => getRenters({ pageNo, pageSize }), {
    ...getCacheSettings(),
    enabled: enabled ?? false,
  });

  return { rentersData: rentersData?.items, rentersIsLoading, rentersIsError };
};
